function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState, useRef } from "react";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useMediaQuery, useTheme } from "@material-ui/core";
import IosArrowBack from "@meronex/icons/ios/IosArrowBack";
import IosArrowForward from "@meronex/icons/ios/IosArrowForward";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function Vendors(_ref) {
  var vendors = _ref.vendors,
    isRewards = _ref.isRewards,
    dots = _ref.dots,
    arrows = _ref.arrows,
    infinite = _ref.infinite,
    vertical = _ref.vertical,
    autoplay = _ref.autoplay,
    autoplaySpeed = _ref.autoplaySpeed,
    speed = _ref.speed,
    pauseOnHover = _ref.pauseOnHover,
    slidesToShow = _ref.slidesToShow,
    xlSlidesToShow = _ref.xlSlidesToShow,
    minSlides = _ref.minSlides,
    customSlide = _ref.customSlide,
    offerCards = _ref.offerCards,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    imageSizes = _useState2[0],
    setImageSizes = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    canScrollLeft = _useState4[0],
    setCanScrollLeft = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    canScrollRight = _useState6[0],
    setCanScrollRight = _useState6[1];
  var scrollRef = useRef(null);
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {},
    replace: function replace() {}
  };
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down("md")); // md and below are considered mobile

  useEffect(function () {
    if (!(vendors !== null && vendors !== void 0 && vendors.length)) return;
    var sizes = {}; // Temporary object to store image size check results
    var loadImageSizes = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return Promise.all(vendors.map(function (vendor) {
                var _vendor$logo;
                if ((_vendor$logo = vendor.logo) !== null && _vendor$logo !== void 0 && _vendor$logo.url) {
                  return new Promise(function (resolve) {
                    var img = new Image();
                    img.src = vendor.logo.url;
                    img.onload = function () {
                      sizes[vendor.id] = img.naturalWidth === 155 && img.naturalHeight === 50;
                      resolve();
                    };
                    img.onerror = resolve; // Handle cases where image fails to load
                  });
                }
                return Promise.resolve();
              }));
            case 1:
              setImageSizes(sizes); // Update state once after all images are processed
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function loadImageSizes() {
        return _ref2.apply(this, arguments);
      };
    }();
    loadImageSizes();
  }, [vendors]);
  var handleBrandClick = function handleBrandClick(path, vendorName, brandId) {
    var _window;
    (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("BrandClicked", {
      brandName: "".concat(vendorName),
      brandId: "".concat(brandId)
    });
    var routePath = isRewards === true ? "/reward-dealListing".concat(path) : "/dealListing".concat(path);
    history.push(routePath);
  };

  // Mobile scroll functions
  var scrollLeft = function scrollLeft() {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: -240,
        behavior: "smooth"
      });
    }
  };
  var scrollRight = function scrollRight() {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: 240,
        behavior: "smooth"
      });
    }
  };
  var handleScroll = function handleScroll() {
    if (scrollRef.current) {
      var _scrollRef$current = scrollRef.current,
        _scrollLeft = _scrollRef$current.scrollLeft,
        scrollWidth = _scrollRef$current.scrollWidth,
        clientWidth = _scrollRef$current.clientWidth;
      setCanScrollLeft(_scrollLeft > 0);
      setCanScrollRight(_scrollLeft < scrollWidth - clientWidth - 1);
    }
  };
  useEffect(function () {
    if (isMobile && scrollRef.current) {
      handleScroll(); // Check initial scroll state
      scrollRef.current.addEventListener("scroll", handleScroll);
      return function () {
        if (scrollRef.current) {
          scrollRef.current.removeEventListener("scroll", handleScroll);
        }
      };
    }
  }, [isMobile, vendors]);
  var settings = {
    dots: false,
    arrows: arrows || true,
    infinite: true,
    vertical: false,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    pauseOnHover: true,
    className: "",
    variableWidth: true
    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />
  };
  console.log("VENDORS", vendors, isMobile);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      id: "AllBrands",
      className: "w-full mx-auto mt-8 lg:mt-8",
      children: isMobile ?
      /*#__PURE__*/
      /* Mobile: Simple horizontal scroll container with arrow navigation */
      _jsxs("div", {
        className: "relative",
        children: [canScrollLeft && /*#__PURE__*/_jsx("button", {
          onClick: scrollLeft,
          className: "absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-2 border border-gray-700",
          children: /*#__PURE__*/_jsx(IosArrowBack, {
            className: "h-5 w-5 text-gray-600"
          })
        }), /*#__PURE__*/_jsx("div", {
          ref: scrollRef,
          className: "flex overflow-x-auto scrollbar-hide gap-4 pb-4 snap-x snap-mandatory pr-8",
          children: vendors === null || vendors === void 0 ? void 0 : vendors.map(function (vendor) {
            var _vendor$logo2;
            return /*#__PURE__*/_jsx("div", {
              className: "flex-shrink-0 snap-center",
              children: /*#__PURE__*/_jsx("img", {
                onClick: function onClick() {
                  return handleBrandClick("?brandID=".concat(vendor.id, "&brandName=").concat(vendor.name), vendor.name, vendor.id);
                },
                src: (_vendor$logo2 = vendor.logo) === null || _vendor$logo2 === void 0 ? void 0 : _vendor$logo2.url,
                className: "cursor-pointer h-28 w-28 rounded-md border-2 border-[#F0F0F0] \n                                            ".concat(imageSizes[vendor.id] ? "object-contain bg-white" : ""),
                alt: vendor.name
              })
            }, vendor.id);
          })
        }), canScrollRight && /*#__PURE__*/_jsx("button", {
          onClick: scrollRight,
          className: "absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-2 border border-gray-700",
          children: /*#__PURE__*/_jsx(IosArrowForward, {
            className: "h-5 w-5 text-gray-600"
          })
        })]
      }) :
      /*#__PURE__*/
      /* Desktop: React Slick slider */
      _jsx("div", {
        className: "overflow-x-hidden",
        children: /*#__PURE__*/_jsx(Slider, _objectSpread(_objectSpread({}, settings), {}, {
          children: vendors === null || vendors === void 0 ? void 0 : vendors.map(function (vendor) {
            var _vendor$logo3;
            return /*#__PURE__*/_jsx("div", {
              className: "mr-4 h-20 w-20 lg:w-[80px] lg:h-[80px] xl:h-[120px] xl:w-[120px]",
              children: /*#__PURE__*/_jsx("img", {
                onClick: function onClick() {
                  return handleBrandClick("?brandID=".concat(vendor.id, "&brandName=").concat(vendor.name), vendor.name, vendor.id);
                },
                src: (_vendor$logo3 = vendor.logo) === null || _vendor$logo3 === void 0 ? void 0 : _vendor$logo3.url,
                className: "cursor-pointer h-20 w-20 lg:w-[80px] lg:h-[80px] xl:h-[120px] xl:w-[120px] rounded-md border-2 border-gray-400 p-2 \n                                            ".concat(imageSizes[vendor.id] ? "object-contain bg-white" : ""),
                alt: vendor.name
              })
            }, vendor.id);
          })
        }))
      })
    })
  });
}
export default Vendors;